export function getBaseUrl(): string {
	const { protocol, host, pathname } = window.location;
	const basePath = `${protocol}//${host}`;

	const url = basePath.endsWith('/') ? `${basePath}` : `${basePath}/`;
	return url;
}
